import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { ref, computed } from 'vue'
import { DialogComponent as EjsDialog } from '@syncfusion/ej2-vue-popups'
import { TextBoxComponent as EjsTextbox } from '@syncfusion/ej2-vue-inputs'
import { RadioButtonComponent as EjsRadiobutton } from '@syncfusion/ej2-vue-buttons'

// Type definitions for better type safety
interface ExportDialogProps {
  isVisible: boolean
}

// Define emits
const DEFAULT_FILE_NAME = 'Diagram'
const DIALOG_WIDTH = '300px'


export default /*@__PURE__*/_defineComponent({
  __name: 'ExportDialog',
  props: {
    isVisible: { type: Boolean }
  },
  emits: ["close", "export"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit

// Define props
const props = __props

// Constants for better maintainability
const EXPORT_FORMATS = ['PNG', 'JPG', 'SVG'] as const
const DIALOG_STYLES = {
  container: { marginTop: '-20px' },
  formatSection: { marginTop: '20px' },
  radioButton: { marginRight: '16px', display: 'inline-block' }
}

// Reactive state for dialog inputs
const fileName = ref<string>(DEFAULT_FILE_NAME)
const selectedFormat = ref<string>('PNG')
const dialogRef = ref<InstanceType<typeof EjsDialog>>()

// Handle export button click with validation
const handleExport = () => {
  // Sanitize and validate file name input
  const sanitizedFileName = fileName.value.trim() || 'diagram'
  const finalFileName = sanitizedFileName.replace(/[^a-zA-Z0-9_-]/g, '_')
  
  emit('export', finalFileName, selectedFormat.value)
  emit('close')
}

// Handle dialog overlay click to close dialog
const handleOverlayClick = () => {
  emit('close')
}

// Handle file name input changes
const handleFileNameChange = (args: any) => {
  fileName.value = args.value
}

// Handle format selection changes
const handleFormatChange = (format: string) => {
  selectedFormat.value = format
}

// Configure dialog action buttons
const dialogButtons = computed(() => [
  {
    click: handleExport,
    buttonModel: { content: 'Export', isPrimary: true },
  },
])

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(EjsDialog), {
    ref_key: "dialogRef",
    ref: dialogRef,
    header: "Export Options",
    showCloseIcon: true,
    isModal: true,
    visible: _ctx.isVisible,
    width: DIALOG_WIDTH,
    buttons: dialogButtons.value,
    closeOnEscape: true,
    onOverlayClick: handleOverlayClick
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        style: _normalizeStyle(DIALOG_STYLES.container)
      }, [
        _createElementVNode("div", null, [
          _cache[0] || (_cache[0] = _createElementVNode("p", null, "File Name", -1)),
          _createVNode(_unref(EjsTextbox), {
            placeholder: "Enter file name",
            value: fileName.value,
            floatLabelType: 'Never',
            onInput: handleFileNameChange
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", {
          style: _normalizeStyle(DIALOG_STYLES.formatSection)
        }, [
          _cache[1] || (_cache[1] = _createElementVNode("p", null, "Format", -1)),
          _createElementVNode("div", null, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(EXPORT_FORMATS, (format, index) => {
              return _createElementVNode("div", {
                key: format,
                style: _normalizeStyle(DIALOG_STYLES.radioButton)
              }, [
                _createVNode(_unref(EjsRadiobutton), {
                  label: format,
                  name: "exportMode",
                  checked: selectedFormat.value === format,
                  onChange: () => handleFormatChange(format)
                }, null, 8, ["label", "checked", "onChange"])
              ], 4)
            }), 64))
          ])
        ], 4)
      ], 4)
    ]),
    _: 1
  }, 8, ["visible", "buttons"]))
}
}

})